import {POST_EVENTS_SEND_CSV_START} from "../../types";

export const events_send_csv = (payload) => ({
  type: POST_EVENTS_SEND_CSV_START,
  payload,
});
